import { Route, Routes } from "react-router-dom";
import { ClerkProvider } from "@clerk/clerk-react";
import { ReactElement } from "react";
import Home from "../pages/Home";
import About from "../pages/About";
import Research from "../pages/Research";
import Contact from "../pages/Contact";
import NotFound from "../pages/NotFound";
import Chat from "../pages/Chat";
import Donations from "../pages/Donations";
import Policies from "../pages/Policies";
import CookiePolicyPage from "../pages/CookiePolicyPage";
import OutcomeChat from "../pages/OutcomeChat";
import RequireAuthentication from "../auth/RequireAuthentication";
import ProductsOutcomeChat from "../pages/ProductsOutcomeChat";
import ResearchChat from "../pages/ResearchChat";
import GeneralChat from "../pages/GeneralChat";
import MentalHealth from "../pages/MentalHealth";
import Quest from "../pages/Products/Quest";
import AuthPage from "../pages/AuthPage";
import Careers from "../pages/Careers";
import RevenueChallenge from "../pages/Challenges/RevenueChallenge";
import BuildersChallenge from "../pages/Challenges/BuildersChallenge";
import Products from "../pages/Products";
import ConceptAi from "../pages/Products/ConceptAi";
import QuestAiRunner from "../pages/Products/QuestAiRunner";
import Initiatives from "../pages/Initiatives";
import EstimatingTruth from "../pages/Initiatives/EstimatingTruth";
import WikipediaAdvocacy from "../pages/Initiatives/WikipediaAdvocacy";
import PsychicAbilityCertification from "../pages/Initiatives/PsychicAbilityCertification";
import Certified from "../pages/Initiatives/PsychicCertification/Certified";
import AssessmentDetail from "../pages/Initiatives/PsychicCertification/AssessmentDetail";
import Apply from "../pages/Initiatives/PsychicCertification/Apply";
import Ethics from "../pages/Initiatives/PsychicCertification/Ethics";
import Prize from "../pages/Initiatives/PsychicCertification/Prize";
import Witness from "../pages/Initiatives/PsychicCertification/Witness";
import Crisis from "../pages/Crisis";
import Change from "../pages/Change";
import OriginStory from "../pages/OriginStory";
import Mentorship from "../pages/Mentorship";

const useClerkRoutes = (): ReactElement => {
  const clerkPubKey: string = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;

  return (
    <ClerkProvider publishableKey={clerkPubKey}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="donate" element={<Donations />} />
        <Route path="research" element={<Research />} />
        <Route path="contact" element={<Contact />} />
        <Route path="about-us" element={<About />} />
        <Route path="origin-story" element={<OriginStory />} />
        <Route path="crisis" element={<Crisis />} />
        <Route path="change" element={<Change />} />
        <Route path="careers" element={<Careers />} />
        <Route path="/mentorship" element={<Mentorship />} />
        <Route path="/challenges/revenue-challenge" element={<RevenueChallenge />} />
        <Route path="/challenges/builders-challenge" element={<BuildersChallenge />} />
        <Route path="/initiatives" element={<Initiatives />} />
        <Route
          path="/initiatives/estimating-truth"
          element={<EstimatingTruth />}
        />
        <Route
          path="/initiatives/wikipedia-advocacy"
          element={<WikipediaAdvocacy />}
        />
        <Route
          path="/initiatives/psychic-ability-certification"
          element={<PsychicAbilityCertification />}
        />
        <Route
          path="/initiatives/psychic-ability-certification/ethics"
          element={<Ethics />}
        />
        <Route
          path="/initiatives/psychic-ability-certification/certified"
          element={<Certified />}
        />
        <Route
          path="/initiatives/psychic-ability-certification/certified/:id"
          element={<AssessmentDetail />}
        />
        <Route
          path="/initiatives/psychic-ability-certification/apply"
          element={<Apply />}
        />
        <Route
          path="/initiatives/psychic-ability-certification/prize"
          element={<Prize />}
        />
        <Route
          path="/initiatives/psychic-ability-certification/witness"
          element={<Witness />}
        />
        <Route path="*" element={<NotFound />} />
        <Route path="/sign-in/*" element={<AuthPage />} />
        <Route path="/sign-up/*" element={<AuthPage />} />
        <Route path="/cookies" element={<CookiePolicyPage />} />
        <Route
          path="/privacy"
          element={<Policies fileName="/privacy.html" />}
        />
        <Route path="/terms" element={<Policies fileName="/terms.html" />} />
        <Route
          path="/chat"
          element={
            <RequireAuthentication>
              <Chat />
            </RequireAuthentication>
          }
        />
        <Route
          path="/outcome-chat"
          element={
            <RequireAuthentication>
              <OutcomeChat />
            </RequireAuthentication>
          }
        />
        <Route path="/products" element={<Products />} />
        <Route
          path="/products/outcome-chat"
          element={<ProductsOutcomeChat />}
        />
        <Route path="/products/research-chat" element={<ResearchChat />} />
        <Route path="/products/general-chat" element={<GeneralChat />} />
        <Route path="/products/mental-health-chat" element={<MentalHealth />} />
        <Route path="/products/quest" element={<Quest />} />
        <Route path="/products/concept-ai" element={<ConceptAi />} />
        <Route path="/products/quest-ai-runner" element={<QuestAiRunner />} />
        {/*  */}
      </Routes>
    </ClerkProvider>
  );
};

export default useClerkRoutes;
